export default __webpack_public_path__ + "static/media/JobSix8.d97b58bb.jpg";